import { Package } from "lucide-react";

export default function Stoklar() {
  return (
    <div className="space-y-6" data-testid="page-stoklar">
      <div>
        <h1 className="text-3xl font-bold tracking-tight flex items-center gap-2">
          <Package className="w-7 h-7 text-amber-500" /> Stoklar
        </h1>
        <p className="text-sm text-slate-500 mt-1">Stok kartları ve stok hareketleri bu menüde yönetilecek.</p>
      </div>
      <div className="bg-white border border-dashed border-slate-300 rounded-lg py-16 text-center" data-testid="stoklar-placeholder">
        <Package className="w-10 h-10 text-slate-300 mx-auto mb-3" />
        <div className="text-sm font-semibold text-slate-600">Stok kartı içeriği hazırlanıyor</div>
        <div className="text-xs text-slate-400 mt-1">Stok kartı alanları netleştiğinde kayıt formu ve liste burada açılacak.</div>
      </div>
    </div>
  );
}
